"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconCog = function SvgIconCog(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "cog icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Cog Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 30.3a6.3 6.3 0 110-12.6 6.3 6.3 0 010 12.6m13.374-4.554c.072-.576.126-1.152.126-1.746 0-.594-.054-1.188-.126-1.8l3.798-2.934a.908.908 0 00.216-1.152l-3.6-6.228a.885.885 0 00-1.098-.396l-4.482 1.8c-.936-.702-1.908-1.314-3.042-1.764l-.666-4.77A.91.91 0 0027.6 6h-7.2a.91.91 0 00-.9.756l-.666 4.77c-1.134.45-2.106 1.062-3.042 1.764l-4.482-1.8a.885.885 0 00-1.098.396l-3.6 6.228a.887.887 0 00.216 1.152l3.798 2.934A15.391 15.391 0 0010.5 24c0 .594.054 1.17.126 1.746l-3.798 2.988a.887.887 0 00-.216 1.152l3.6 6.228c.216.396.702.54 1.098.396l4.482-1.818c.936.72 1.908 1.332 3.042 1.782l.666 4.77a.91.91 0 00.9.756h7.2a.91.91 0 00.9-.756l.666-4.77c1.134-.468 2.106-1.062 3.042-1.782l4.482 1.818c.396.144.882 0 1.098-.396l3.6-6.228a.908.908 0 00-.216-1.152l-3.798-2.988z"
  }));
};

var _default = SvgIconCog;
exports.default = _default;